type Props = {
  children: React.ReactNode
}

const OverlinedSmall = ({ children }: Props) => {
  return (
    <div className="inline-block mx-auto border-t border-blue pt-4 px-2 text-sm">
      {children}
    </div>
  )
}

export default OverlinedSmall
